import { api_configs } from 'src/api-services';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { dataRequest, dataSuccess, dataFailure } from 'src/service/Fetures/ProfileSlice';

export const FetchApiSlice = createAsyncThunk(
  'ProfileSlice/FetchApiSlice',
  async (payload, { dispatch }) => {
    try {
      dispatch(dataRequest());
      const res = await axios({
        method: "GET",
        url: api_configs.getProfile,
        headers: {
          token: window.localStorage.getItem("token")
        },
      });
      if (res.data.responseCode === 200) {
        dispatch(dataSuccess(res.data.result));
      }
    } catch (error) {
      dispatch(dataFailure(error.toString()));
    }
  }
);

